module.exports = __webpack_public_path__ + "img/Backoffice-Homepage.375c22e.png";